import { Container, Flex, HStack, Heading, IconButton, IconButtonProps } from '@chakra-ui/react';
import IconArrowBack from 'assets/icons/icon-arrow-back.svg?react';
import React, { PropsWithChildren } from 'react';
import { Link } from 'react-router-dom';
import WrapperDialog, { DialogProps } from './WrapperDialog';

export type HeaderBarProps = PropsWithChildren<{
  title: string;
  subtitle?: string;
  backTo: string;
  dialogProps?: DialogProps;
}>;

const BackButton = React.forwardRef(({ backTo, ...props }: Omit<IconButtonProps, 'aria-label'> & { backTo: string }, ref) => (
  <IconButton 
    ref={ref}
    as={Link}
    icon={<IconArrowBack />}
    to={backTo}
    mr="19px"
    {...props}
    aria-label="Voltar"
  />
));

export default function HeaderBarInternal({ title, subtitle, backTo, children, dialogProps }: HeaderBarProps) {
  return (
    <Container
      variant="internal"
      py={0}
    >
      <HStack 
        w="full"
        pos="relative"
        spacing="19px" 
        py={{ base: '23px', lg: '23px' }}
      >
        <Flex
          ml={{ lg: '-60px' }}
          alignItems="center"
        >
        { dialogProps ? (
          <WrapperDialog {...dialogProps}>
            <BackButton backTo={backTo} />
          </WrapperDialog>
        ) : (
          <BackButton backTo={backTo} />
        )}
          
          <Heading as="h2" size="h2">
            {title}
            {!!subtitle && <span>{subtitle}</span> }
          </Heading>
        </Flex>
        {children}
      </HStack>
    </Container>
  )
}
